export default __webpack_public_path__ + "static/media/footerBg.833b1243.jpg";